import React from 'react';
import { StoryItem } from './StoryItem';
import styles from './StorySection.module.scss';

const storyData = [
  {
    number: '001',
    title: 'AI-Driven\nCreativity',
    description: 'Troak uses cutting-edge AI to generate entire stories in just 5 minutes, a process that once took weeks.'
  },
  {
    number: '002',
    title: 'Personalized Experience',
    description: 'Like your favorite social platforms, Troak personalizes your feed, offering tailored stories that match your preferences'
  },
  {
    number: '003',
    title: 'Dynamic, Player-Driven Narratives',
    description: 'Every choice you make shapes the story, creating a unique, immersive experience every time you play.'
  }
];

export const StorySection = () => {
  return (
    <div className={styles.storySection}>
      <div className={styles.storyContainer}>
        <div className={styles.RightStoryHeader}>mystery</div>
        {storyData.map((story, index) => (
          <StoryItem
            key={index}
            number={story.number}
            title={story.title}
            description={story.description}
          />
        ))}
      </div>
      <div className={styles.backgroundText}>Curiosity</div>
    </div>
  );
};

